<script setup lang="ts">
import SearchBusForm from './SearchBusForm.vue';
import SearchFlightForm from './SearchFlightForm.vue';
import SearchHotelForm from './SearchHotelForm.vue';
import SearchTaxiForm from './SearchTaxiForm.vue';
import SearchTrainForm from './SearchTrainForm.vue';
import { ReserveType } from '@utils/itinerary';

const { isChangeSearch, loading } = defineProps<{
    isChangeSearch?: boolean;
    loading?: boolean;
}>();

const emit = defineEmits<{
    forceReload: [];
}>();

// FIX: bad Performace
const mapReserveTypeToForm: Record<ReserveType, any | null> = {
    [ReserveType.Flight]: SearchFlightForm,
    [ReserveType.Hotel]: SearchHotelForm,
    [ReserveType.Train]: SearchTrainForm,
    [ReserveType.Bus]: SearchBusForm,
    [ReserveType.Taxi]: SearchTaxiForm,
    [ReserveType.Route]: null,
};

const searchFormStore = useSearchFormStore();
const currentSearchForm = useCurrentSearchForm();
const analyticsStore = useAnalyticsStore();
const currentForm = computed(
    () => mapReserveTypeToForm[searchFormStore.reserveType]
);
watch(
    [
        () => searchFormStore.reserveType,
        () => currentSearchForm.value.searchMode,
    ],
    () => {
        analyticsStore.resetSearchInputSearchCount();
    }
);
</script>

<template>
    <component
        :is="currentForm"
        :is-change-search
        :loading
        @force-reload="emit('forceReload')"
    />
</template>
